module.exports = __webpack_public_path__ + "img/color-r-2@2x.943eae4.webp";